export default "__VITE_PUBLIC_ASSET__a57ce7b3__"